import { render } from "./Result.vue?vue&type=template&id=1e33ce4b&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=1e33ce4b&scoped=true&lang=css"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e33ce4b"]])

export default __exports__